export default 'Increase number';